module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "include-options": "",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": false,
      "include-export-to-excel": false,
      "selectable": false,
      "option-buttons": _vm.optionButtonsCheckin
    },
    on: {
      "custom-button": _vm.customButtons
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.numReservation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name) + " " + _vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getChannelName(props.row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.roomType)), _c('br'), _vm._v(_vm._s(props.row.codeRoom))]), _vm._v(" "), _c('td', {
          staticClass: "td-state"
        }, [_c('span', {
          style: (_vm.customColor(props.row))
        }, [_vm._v("\n\t\t\t\t" + _vm._s(props.row.paymentStatus) + "\n\t\t\t")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.dateEnd)), _c('br'), _vm._v(_vm._s(props.row.dateEndHours))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.employee))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.total))])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-642f3785","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/reports/sub-component/report-table.vue
// module id = 1651
// module chunks = 25